const remote = require('electron').remote;

var quit = document.getElementById("exit");
var minimize = document.getElementById("min");
var maximize = document.getElementById("max");

quit.addEventListener("click",function closeWindow(){
	remote.getCurrentWindow().close()
});

minimize.addEventListener("click",function minimizeWindow(){
	remote.BrowserWindow.getFocusedWindow().minimize();
});

maximize.addEventListener("click",function maximizeWindow(){
	if(!remote.BrowserWindow.getFocusedWindow().isMaximized()){
		remote.BrowserWindow.getFocusedWindow().maximize();
		maximize.innerHTML='<svg class="icon" viewBox="0 0 16 16" class="bi bi-dash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">'+'<path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>'+'</svg>';
	}
	else if(remote.BrowserWindow.getFocusedWindow().isMaximized()){
		remote.BrowserWindow.getFocusedWindow().restore();
		maximize.innerHTML='<svg class="icon max-icon" viewBox="0 0 16 16" class="bi bi-square" fill="currentColor" xmlns="http://www.w3.org/2000/svg">'+'<path fill-rule="evenodd" d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>'+'</svg>';
	}
});


